import logger from './logger'
import $ from 'jquery'
import dfp from './ads/dfp/dfp'

const ads = {};

/**
 * Method to inject ads scripts into the dom
 */
const handeDomInjections = () => {
    dfp.domInjection(
        'https://securepubads.g.doubleclick.net/tag/js/gpt.js'
    );
};

/**
 * Method to handle (initialize/push) sas banners
 */
const handleDfp = () => {
    dfp.initializedfp();
    if (!window.googletag) {
        logger.log("No Dfp instance available");
        return
    }

    $('cs-ads').each((_idx, el) => {
        const {
            formatId,
            condition,
            id,
        } = $(el).data();

        if (dfp.matchesCondition(condition)) {
            $(el).attr("id", id)
        }

        dfp.push(formatId, condition)
    })
};

ads.init = () => {
    handeDomInjections();
    handleDfp()
};

export default ads